import { reduxForm } from 'redux-form';
import validateTool from 'validate.js';
import BestPlayerVotingForm from './BestPlayerVoting';
import { TYPE_BEST_PLAYER } from '../../../../../api/voting/base';
import BestPlayerVoting from '../../../../../api/voting/bestPlayer';
import EventActions from '../../../../../actions/event';
import { convertDate, parseVotingStatuses } from '../helper';

const validate = (data) => {
  return validateTool(data, BestPlayerVoting.validateConstraints) || {};
};

export default reduxForm(
  {
    form: 'best_player_voting',
    fields: [
      'voting',
      'players',
      'start_time',
      'end_time'
    ],
    returnRejectedSubmitPromise: true,
    validate
  },
  (state) => {
    let { event } = state;
    let voting = event.model.bestPlayerVoting || new BestPlayerVoting();

    let data = parseVotingStatuses(voting);
    Object.assign(data, {
      initialValues: prepareBestPlayerVoting(voting)
    });

    return data;
  },
  (dispatch) => ({
    announceResult: (data) => dispatch(EventActions.announceResultVoting(TYPE_BEST_PLAYER, data)),
    save: async (data) => await dispatch(EventActions.saveVoting(TYPE_BEST_PLAYER, data)),
    publish: (data) => dispatch(EventActions.publishVoting(TYPE_BEST_PLAYER, data))
  })
)(BestPlayerVotingForm);


function prepareBestPlayerVoting(voting) {
  if ( voting ) {
    return {
      players: voting.players,
      start_time: convertDate(voting.start_time),
      end_time: convertDate(voting.end_time)
    };
  } else {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/BestPlayerVoting/index.js